const BASE = process.env.REACT_APP_API_URL || '/api';

function getToken() {
  return localStorage.getItem('token');
}

async function req(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  if (res.status === 401) {
    localStorage.removeItem('token');
    window.location.reload();
    return;
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('text/csv')) return res.blob();
  return res.json();
}

// Bild-Upload: Rohbody statt JSON, damit das Bild nicht als Base64 aufgeblaeht wird.
async function uploadAttachment(file) {
  const res = await fetch(`${BASE}/attachments`, {
    method: 'POST',
    headers: {
      'Content-Type': file.type,
      'X-Filename': encodeURIComponent(file.name || 'screenshot'),
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
    },
    body: file,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Upload fehlgeschlagen (HTTP ${res.status})`);
  }
  const data = await res.json();
  return { ...data, url: `${BASE}/attachments/${data.id}` };
}

export const api = {
  // Attachments
  uploadAttachment,
  attachmentUrl: (id) => `${BASE}/attachments/${id}`,
  deleteAttachment: (id) => req('DELETE', `/attachments/${id}`),

  // Auth
  authStatus: () => req('GET', '/auth/status'),
  login: (email, password) => req('POST', '/auth/login', { email, password }),
  register: (email, password, name) => req('POST', '/auth/register', { email, password, name }),

  // Tasks
  getTasks: (filters = {}) => {
    const q = new URLSearchParams(Object.entries(filters).filter(([, v]) => v)).toString();
    return req('GET', `/tasks${q ? '?' + q : ''}`);
  },
  getTask: (id) => req('GET', `/tasks/${id}`),
  createTask: (data) => req('POST', '/tasks', data),
  updateTask: (id, data) => req('PUT', `/tasks/${id}`, data),
  deleteTask: (id) => req('DELETE', `/tasks/${id}`),
  exportTasksCsv: () => req('GET', '/tasks/export/csv'),
  linkTaskOkr: (taskId, keyResultId) => req('POST', `/tasks/${taskId}/okr-links`, { key_result_id: keyResultId }),
  unlinkTaskOkr: (taskId, krId) => req('DELETE', `/tasks/${taskId}/okr-links/${krId}`),

  // OKRs
  getGoals: (year) => req('GET', `/okrs/goals${year ? '?year=' + year : ''}`),
  createGoal: (data) => req('POST', '/okrs/goals', data),
  updateGoal: (id, data) => req('PUT', `/okrs/goals/${id}`, data),
  deleteGoal: (id) => req('DELETE', `/okrs/goals/${id}`),

  getObjectives: (params = {}) => {
    const q = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
    return req('GET', `/okrs/objectives${q ? '?' + q : ''}`);
  },
  createObjective: (data) => req('POST', '/okrs/objectives', data),
  updateObjective: (id, data) => req('PUT', `/okrs/objectives/${id}`, data),
  deleteObjective: (id) => req('DELETE', `/okrs/objectives/${id}`),

  getKeyResults: (objectiveId) => req('GET', `/okrs/key-results${objectiveId ? '?objective_id=' + objectiveId : ''}`),
  createKeyResult: (data) => req('POST', '/okrs/key-results', data),
  updateKeyResult: (id, data) => req('PUT', `/okrs/key-results/${id}`, data),
  deleteKeyResult: (id) => req('DELETE', `/okrs/key-results/${id}`),

  getOkrTree: (year) => req('GET', `/okrs/tree?year=${year}`),

  // Planning
  getDayPlan: (date) => req('GET', `/planning/day/${date}`),
  saveDayPlan: (date, data) => req('PUT', `/planning/day/${date}`, data),
  getDayCarryover: (date) => req('GET', `/planning/day/${date}/carryover`),
  getCalendar: (from, to) => {
    const q = new URLSearchParams({ ...(from && { from }), ...(to && { to }) }).toString();
    return req('GET', `/planning/calendar${q ? '?' + q : ''}`);
  },
  getWeekPlan: (weekId) => req('GET', `/planning/week/${weekId}`),
  saveWeekPlan: (weekId, data) => req('PUT', `/planning/week/${weekId}`, data),
  getWeeks: (year) => req('GET', `/planning/weeks${year ? '?year=' + year : ''}`),

  // Settings
  getSettings: () => req('GET', '/settings'),
  saveSettings: (data) => req('PUT', '/settings', data),

  // Period-Marks (per-day/per-week strikethrough)
  getMarks: (params = {}) => {
    const q = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
    return req('GET', `/marks${q ? '?' + q : ''}`);
  },
  setMark: (data) => req('POST', '/marks', data),
  unsetMark: ({ task_id, period_type, period_date }) => {
    const q = new URLSearchParams({ task_id, period_type, period_date }).toString();
    return req('DELETE', `/marks?${q}`);
  },

  // Canvas (positions + dependencies)
  getCanvas: () => req('GET', '/canvas'),
  saveCanvasPositions: (items) => req('PUT', '/canvas/positions', items),
  resetCanvasPositions: () => req('DELETE', '/canvas/positions'),
  createDependency: ({ from_task_id, to_task_id }) =>
    req('POST', '/canvas/dependencies', { from_task_id, to_task_id }),
  deleteDependency: ({ id, from_task_id, to_task_id }) => {
    const q = new URLSearchParams(
      id ? { id } : { from_task_id, to_task_id }
    ).toString();
    return req('DELETE', `/canvas/dependencies?${q}`);
  },
};
